
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Country } from '../../lib/models/Country'
import { RegisterUserDTO } from '../../lib/modules/auth/dtos/RegisterUserDTO'

@Component({})
export default class RegisterAddress extends Vue {
  @Prop({ required: true }) user!: RegisterUserDTO

  countries: Country[] = []

  mounted () {
    this.loadCountries()
  }

  async loadCountries () {
    this.countries = await Country.getAll({})
  }
}
